import React, { useRef, createContext } from "react";

export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const relativePerformance = useRef(null);

  const refs = { componentSize, relativePerformance };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
